import handleHtmlData from 'utils/global/handleHtmlData'
import formatDate from 'utils/dates/formatDate'
import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'
import { formatCityStatePostal } from 'utils/tinyMCE/formatCityStatePostal'
import { escapeHtml } from '@messenger/utils'

export const serviceTemplate = ({
  editorProps,
  templateProps,
  firstInsertion = false,
  dataTemplateAttribute,
}) => {
  const { caseDetails, selectedTheme, pageSetLocale } = editorProps
  const { serviceId } = templateProps
  const templateData = { serviceId }
  const encodedProperties = handleHtmlData.encode(templateData)
  const services = caseDetails?.services
  const currentService = services.find((s) => s.id === serviceId)

  if (!currentService) return ''

  const {
    location,
    address,
    city,
    state,
    postal_code,
    date,
    start_time,
    end_time,
  } = currentService

  const locationParagraph = location
    ? `<p><span>${escapeHtml(location)}</span></p>`
    : ''

  const addressString = address ? escapeHtml(`${address}`) : ''
  const addressParagraph = address ? `<p><span>${addressString}</span></p>` : ''

  // Build city/state/postal using smart comma placement utility
  const cityStatePostalString = formatCityStatePostal({
    city,
    state,
    postal: postal_code,
  })

  const cityParagraph = cityStatePostalString
    ? `<p><span>${escapeHtml(cityStatePostalString)}</span></p>`
    : ''

  // TODO: add this to a consts file in the shared package once that's ready
  const formattedDate = formatDate(
    date,
    'dddd, MMMM D, YYYY',
    true,
    pageSetLocale,
  )
  const dateParagraph = date
    ? `<p><span>${escapeHtml(formattedDate)}</span></p>`
    : ''

  const startTimeString = start_time ? escapeHtml(`${start_time}`) : ''
  const endTimeString = end_time ? escapeHtml(`${end_time}`) : ''
  const hasStartTime = Boolean(start_time)
  const hasEndTime = Boolean(end_time)
  const hasFullTimeRange = hasStartTime && hasEndTime
  let timeParagraph = ''
  if (hasFullTimeRange) {
    timeParagraph = `<p><span>${startTimeString} to ${endTimeString}</span></p>`
  } else if (hasStartTime) {
    timeParagraph = `<p><span>${startTimeString}</span></p>`
  }

  const themeStyles = getThemeStylesForTemplate({
    selectedTheme,
    editor: editorProps.editor,
    firstInsertion,
  })

  const html = `
    <div data-template="${dataTemplateAttribute}" data-properties="${encodedProperties}" class="mceNonEditable" style="${themeStyles}">
      ${locationParagraph}
      ${addressParagraph}
      ${cityParagraph}
      ${dateParagraph}
      ${timeParagraph}
    </div>
  `
  return html
}

export default serviceTemplate
